import { useContext } from 'react'

import { context } from './context'

export const useSnackbar = () => useContext(context)
